// Left panel icons
import * as background from './builder/background/index.js';
import * as builder from './builder/index.js';
//Campaign
import arrowDown from './campaign/arrowDown.svg';
import customPlatform from './campaign/customPlatform.svg';
import draggerLines from './campaign/draggerLines.svg';
import importIconCompact from './campaign/import_compact.svg';
import importIcon from './campaign/import_icon.svg';
import rightArrow from './campaign/rightIcon.svg';
import search from './campaign/search.svg';
import starActive from './campaign/star_active.svg';
import { linkedin, web } from './company/index.js';
import * as insightsPack from './insights/index.js';
// notifications
import notificationBell from './notifications/bell.svg';
import certificate from './notifications/certificate.svg';
import planet from './notifications/planet.svg';
import notificationReject from './notifications/reject.svg';
import notificationSuccess from './notifications/success.svg';
import notificationWarning from './notifications/warning.svg';
// Platforms
import * as platforms from './platforms/index.js';
import arrowLeft from './shared/arrowLeft.svg';
import circleClose from './shared/circleClose.svg';
// shared
import collapseArrows from './shared/collapseArrows.svg';
import expandArrows from './shared/expandArrows.svg';
import filledArrow from './shared/filledArrow.svg';
import info from './shared/info.svg';
import pencil from './shared/pencil.svg';
import platformsArrows from './shared/platformsArrows.svg';
import spinner from './shared/spinner.svg';
import sidebarIcons from './sidebar/index.js';

const Icons = {
  rightArrow,
  arrowLeft,
  info,
  draggerLines,
  alert,
  search,
  circleClose,
  arrowDown,
  starActive,
  importIconCompact,
  importIcon,
  // * backward for legacy
  platforms,
  customPlatform,
  pencil,
  insightsPack,
  builder,
  filledArrow,
  spinner,
  planet,
  notificationSuccess,
  notificationWarning,
  notificationBell,
  notificationReject,
  certificate,
  background,
  sidebarIcons,
  web,
  linkedin,
  collapseArrows,
  expandArrows,
  platformsArrows,
};

export default Icons;
